// SaveSessionInput.jsx
import React, { useState } from 'react';
import styles from "./saveSessionInput.module.css"

const SaveSessionInput = ({ name, desc, onNameChange, onDescChange }) => {

  return (
    <div className={styles.container}>
      <input
        type="text"
        value={name}
        onChange={(e) => onNameChange(e)}
        placeholder="Session Name"
      />
      
      <textarea
        value={desc}
        onChange={(e) => onDescChange(e)}
        placeholder="Session Description"
      />
    </div>
  );
};

export default SaveSessionInput;